export enum PUBLIC_PAGES {
  LOGIN = "/login",
}

export enum PRIVATE_PAGES {
  HOME = "/",
  EMPTY = "/",
  MESSAGES = '/messages',
  DASHBOARD = "dashboard",

  CATEGORIES = '/categories',
  CREATE_CATEGORY = '/create-category',
  UPDATE_CATEGORY = '/update-category/:categoryId',

  CERTIFICATES = '/certificates',
  CREATE_CERTIFICATE = '/create-certificate',
  UPDATE_CERTIFICATE = '/update-certificate/:certificateId',

  PRODUCTS = '/products',
  CREATE_PRODUCTS = '/create-products',
  UPDATE_PRODUCT = '/update-product/:productId',
}
